import { OptionalFeature } from "../../../../base/domain/drawing";
import { ILengthAlertBehavior } from "./ILengthAlertBehavior";

export class LengthAlertBehavior extends OptionalFeature {
  constructor(
    isEnable: boolean     = false,
    public length: number = 0,
    public shouldValidate: boolean = false,
  ) {
    super(isEnable);
  }

  clone(): LengthAlertBehavior {
    return new LengthAlertBehavior(this.isEnable, this.length, this.shouldValidate);
  }

  static from(source: ILengthAlertBehavior): LengthAlertBehavior {
    return new LengthAlertBehavior(source.isEnable, source.length, source.shouldValidate);
  }

  static to(source: LengthAlertBehavior): ILengthAlertBehavior {
    return {
      isEnable: source.isEnable,
      length: source.length,
      shouldValidate: source.shouldValidate,
    };
  }
}
